import React from 'react';

import { OperatorFlowLink } from 'src/components/OperatorFlowLink';

export const OperatorFlowLinkListCell = ({
  item,
}: {
  item: OperatorFlowJob;
}) => (
  <div>
    {item.redeployedOperatorFlowJobIds?.map((link: string) => (
      <div key={link}>
        <OperatorFlowLink operatorFlowJobId={link}>{link}</OperatorFlowLink>
      </div>
    ))}
  </div>
);
